import React, { Component } from 'react';
import Slider from 'react-slick';
import PropTypes from 'prop-types';
import { get } from 'lodash';

function CarouselArrow({ label, ...props }) {
  return (
    <button {...props} aria-label={label}>
      {label}
    </button>
  );
}

function Dots({ active, handleClick, id, total }) {
  if (!total) {
    return null;
  }

  return (
    <ul className="slick-dots">
      {[...Array(total)].map((_dot, index) => (
        <li
          className={active === index ? 'slick-active' : ''}
          key={`${id}-dot-${index}`}
        >
          <button
            onClick={() => {
              handleClick(index);
            }}
            aria-label={`Slide ${index + 1}`}
          >
            Slide {index + 1}
          </button>
        </li>
      ))}
    </ul>
  );
}

class Carousel extends Component {
  constructor(props) {
    super(props);

    this.updateActive = this.updateActive.bind(this);
    this.handleDotClick = this.handleDotClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.updateAccessibility = this.updateAccessibility.bind(this);

    this.state = {
      active: 0,
    };
  }

  componentDidMount() {
    this.updateAccessibility();
  }

  // Additional accessibility enhancements
  // not available in version of react-slick
  updateAccessibility() {
    const { infinite } = this.props;

    // Toggle aria-hidden for screenreaders
    this.carouselRef.getElementsByClassName('slick-slide').forEach((el) => {
      // Definitely a bit hacky :-(
      const hasActiveClass = el.classList.contains('slick-active');
      const hasActiveProperty = get(el, 'style.outline') === 'none';
      const hiddenIdentifier =
        infinite === false
          ? !hasActiveClass
          : !hasActiveProperty || !hasActiveClass;

      el.setAttribute('aria-hidden', hiddenIdentifier);
    });
  }

  updateActive(index) {
    this.setState({
      active: index,
    });
  }

  handleDotClick(index) {
    this.updateActive(index);
  }

  handleChange(index) {
    this.updateActive(index);
    this.updateAccessibility();
  }

  render() {
    const { children, dots, id, ...options } = this.props;
    const { active } = this.state;

    return (
      <div
        className="mt-carousel"
        aria-live="polite"
        id={id}
        ref={(elem) => {
          this.carouselRef = elem;
        }}
      >
        {dots && (
          <Dots
            active={active}
            id={id}
            total={children.length}
            handleClick={this.handleDotClick}
          />
        )}
        <Slider
          {...options}
          slickGoTo={active}
          nextArrow={<CarouselArrow label="next" />}
          prevArrow={<CarouselArrow label="previous" />}
          afterChange={this.handleChange}
        >
          {children.map((child, index) => (
            <div key={`${id}-item-${index}`}>{child}</div>
          ))}
        </Slider>
      </div>
    );
  }
}

Carousel.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string,
  infinite: PropTypes.bool,
};
// + any react slick options

export { Carousel };
